const drivers = {
  table: {
    filters: {
      suppliers: 'Fleets',
    },
  },

  forms: {
    information: {
      supplier: {
        header: 'Fleets',
        fields: {
          suppliers: 'Fleets',
        },
      },
    },
  },
};

export default drivers;
